import hoist from 'hoist-non-react-statics'
import React from 'react'


// Can be extended with object parameter but not necessary now
export function getTranslationFunction(locales) {
  return function wrapWithTranslationFunction(key) {
    if (locales) {
      if (locales[key]) {
        return locales[key]
      }

      // eslint-disable-next-line
      console.error('[TranslationUtils] Missing key:', key)

      return key
    }
    return key
  }
}

export const Context = React.createContext()

export function useContext() {
  return React.useContext(Context)
}

export function localize(WrappedComponent) {
  function Localized(props) {
    return (
      <Context.Consumer>
        {
          context => (
            <WrappedComponent
              {...context}
              {...props}
            />
          )
        }
      </Context.Consumer>
    )
  }

  Localized.WrappedComponent = WrappedComponent

  return hoist(Localized, WrappedComponent)
}
